<template>
  <div>
    <p class="title is-4">
      Eight連携
    </p>
    <p class="subtitle is-6">
      名刺管理アプリEightから会社データを登録します。
    </p>

    <b-collapse :open="false" aria-id="how-to-download">
      <template #trigger>
        <b-button
          rounded
          label="EightからのCSVダウンロード方法"
          type="is-info"
          aria-controls="how-to-download"
          class="mb-5"
        />
      </template>
      <div class="notification mb-5">
        <div class="content">
          <div class="content">
            <h4>
              CSVのダウンロード方法
            </h4>
            <a href="https://8card.net/export/csv_orders" target="_blank" rel="noopener">CSVダウンロードページ</a>
            <p>ダウンロードしたCSVは編集することなく使えます。そのままアップロードしてください。</p>
            <b-image
              :src="require('@/assets/img/eight_csv_download.png')"
              alt="how-to-csv-download"
            />
          </div>
        </div>
      </div>
    </b-collapse>


    <b-field class="file " :class="{'has-name': !!file}" grouped>
      <b-upload v-model="file" class="file-label">
        <span class="file-cta">
          <b-icon class="file-icon" icon="upload" />
          <span class="file-label">CSVファイルを選択してください</span>
        </span>
        <span v-if="file" class="file-name">
          {{ file.name }}
        </span>
      </b-upload>
      <p class="control">
        <b-button class="button is-primary" @click="storeCsv">
          アップロード
        </b-button>
      </p>
    </b-field>

    <div v-if="rows.length" id="companies">
      <p class="title is-5">
        登録する会社データ
      </p>
      <p class="subtitle is-6">
        システム未登録の会社データです({{ rows.length }}件)<br>
        登録から除外したいデータは一番右のチェックを外してください。<br>
        問題なければ最下部にある <strong>会社データ登録</strong> ボタンを押してください。
      </p>
      <b-table
        :data="rows"
        class="mb-5"
      >
        <b-table-column v-slot="props" label="会社名">
          {{ props.row.company_name }}
        </b-table-column>

        <b-table-column v-slot="props" label="電話番号">
          {{ viewTel(props.row.tel, props.row.mobile_tel) | tel }}
        </b-table-column>

        <b-table-column v-slot="props" label="Eメールアドレス">
          {{ props.row.email }}
        </b-table-column>

        <b-table-column v-slot="props" label="登録">
          <b-checkbox v-model="registerChecks[props.row.line_number]" />
        </b-table-column>
      </b-table>

      <p class="control">
        <b-button class="button is-primary" size="is-large" @click="storeCompanies">
          会社データ登録
        </b-button>
      </p>
    </div>
    <div v-else-if="isUploaded">
      <div class="notification is-warning is-light">
        すべて登録済みです
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Eight",
  data() {
    return {
      isUploaded: false,
      file: null,
      rows: [],
      registerChecks: [],
      logId: null
    }
  },
  methods: {
    viewTel(tel, mobileTel) {
      if (tel !== '') {
        return tel
      } else if (mobileTel !== '') {
        return mobileTel
      } else {
        return ''
      }
    },
    storeCsv() {
      this.openLoading()
      const params = new FormData()
      params.append('csv', this.file)
      const headers = {'content-type': 'multipart/form-data'}
      return this.$http.post('/eight/upload', params, {
        headers,
      }).then(response => {
        this.isUploaded = true
        this.logId = response.data.logId
        this.rows = response.data.rows
        this.registerChecks = []
        for (const row of this.rows) {
          this.registerChecks[row.line_number] = true
        }
      }).catch(error => {
        console.dir(error)
      }).finally(() => {
        this.closeLoading()
      })
    },
    storeCompanies() {
      this.openLoading()
      this.$http.post('/eight/' + this.logId + '/register', {
        registerChecks: this.registerChecks
      }).then(() => {
        this.$buefy.toast.open(`登録が完了しました`)
        this.rows = []
        this.file = null
        this.isUploaded = false
      }).catch(error => {
        console.dir(error)
      }).finally(() => {
        this.closeLoading()
      })
    }
  },
}
</script>

<style scoped>

#companies {
  margin-top: 50px;
}

.notification {
  max-width: 900px;
}

>>> img {
  max-width: 900px;
  box-shadow: 5px 5px 10px;
  border: 1px solid #000;
}

</style>